import {notification} from "antd";

const successNotification = (message: string, description?: string) => {
    notification.success({title: message, description, placement: "bottomRight"})
}

const errorNotification = (message: string, description?: string) => {
    notification.error({title: message, description, placement: "bottomRight"})
}


export {successNotification, errorNotification}
